export default "__VITE_ASSET__B8q0Qj3t__"